import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

const lineVariant = {
  hidden: { y: "115%" },
  visible: (i) => ({
    y: 0,
    transition: { duration: 1, delay: 0.15 + i * 0.12, ease: [0.76, 0, 0.24, 1] },
  }),
};

// Masked line-by-line reveal on mount. `lines` is an array of nodes/strings.
export const MaskText = ({ lines, className = "", as = "span" }) => {
  const Tag = motion[as] || motion.span;
  return (
    <span className="block">
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.06em]">
          <Tag
            className={`block ${className}`}
            custom={i}
            variants={lineVariant}
            initial="hidden"
            animate="visible"
          >
            {l}
          </Tag>
        </span>
      ))}
    </span>
  );
};

export const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, delay: i * 0.1, ease: EASE },
  }),
};
